"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataDelegateRecordBeet = exports.MetadataDelegateRecord = void 0;
const web3 = __importStar(require("@solana/web3.js"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const Key_1 = require("../types/Key");
class MetadataDelegateRecord {
    constructor(key, bump, mint, delegate, updateAuthority) {
        this.key = key;
        this.bump = bump;
        this.mint = mint;
        this.delegate = delegate;
        this.updateAuthority = updateAuthority;
    }
    static fromArgs(args) {
        return new MetadataDelegateRecord(args.key, args.bump, args.mint, args.delegate, args.updateAuthority);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return MetadataDelegateRecord.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) {
            throw new Error(`Unable to find MetadataDelegateRecord account at ${address}`);
        }
        return MetadataDelegateRecord.fromAccountInfo(accountInfo, 0)[0];
    }
    static gpaBuilder(programId = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.metadataDelegateRecordBeet);
    }
    static deserialize(buf, offset = 0) {
        return exports.metadataDelegateRecordBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.metadataDelegateRecordBeet.serialize(this);
    }
    static get byteSize() {
        return exports.metadataDelegateRecordBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(MetadataDelegateRecord.byteSize, commitment);
    }
    static hasCorrectByteSize(buf, offset = 0) {
        return buf.byteLength - offset === MetadataDelegateRecord.byteSize;
    }
    pretty() {
        return {
            key: 'Key.' + Key_1.Key[this.key],
            bump: this.bump,
            mint: this.mint.toBase58(),
            delegate: this.delegate.toBase58(),
            updateAuthority: this.updateAuthority.toBase58(),
        };
    }
}
exports.MetadataDelegateRecord = MetadataDelegateRecord;
exports.metadataDelegateRecordBeet = new beet.BeetStruct([
    ['key', Key_1.keyBeet],
    ['bump', beet.u8],
    ['mint', beetSolana.publicKey],
    ['delegate', beetSolana.publicKey],
    ['updateAuthority', beetSolana.publicKey],
], MetadataDelegateRecord.fromArgs, 'MetadataDelegateRecord');
//# sourceMappingURL=MetadataDelegateRecord.js.map